// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1CUNx","productName":"Table_productName__foNyI"};